import axios from 'axios';

const API_KEY = 'AIzaSyDC-sC_4da6pDn86imxY769_muQByHKP_0';
export const CONTENT_VIDEO_PLAYLISTS = [
  'PLrKBYFvqv3FWLBZl8RezYKruwaRxmcJ9F',
  'PLPv28hPx15hmhZQzfyiUa_EutDlDisaWi',
  'PL1lpcJkpcxNl3ro1bEob_LI7g94qe2HAw',
];

// export const getAllVideos = videoIds => {
//   const parts = ['snippet', 'statistics', 'contentDetails'];
//   const config = {
//     method: 'get',
//     url: `https://youtube.googleapis.com/youtube/v3/videos?id=${videoIds.join(
//       ','
//     )}&part=${parts.join(',')}&key=${API_KEY}`,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   };
//   return axios(config);
// };

// export const getAllVideosFromPlaylist = (playlistId, nextPageToken = '') => {
//   const parts = 'contentDetails,snippet';
//   // const PLAYLIST_ID = 'PLe4KxMgmhwyjTxx_k_-Xh9hYIvlMGYfRm';
//   const config = {
//     method: 'get',
//     url: `https://youtube.googleapis.com/youtube/v3/playlistItems?key=${API_KEY}&part=${parts}&playlistId=${playlistId}&maxResults=200&pageToken=${nextPageToken}`,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   };
//   return axios(config);
// };

export const getVideosFromCache = ({ offset, sortBy }) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getContentVideos?offset=${offset}&sortBy=${sortBy}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};

export const getTopVideoTags = () => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/getTopTags`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};

export const searchVideos = ({ searchText, offset }) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/searchContentVideos?searchText=${searchText}&offset=${offset}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};

export const getSearchSuggestions = () => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_HOST}/jobseeker/searchSuggestions`,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return axios(config);
};
